import type { MarketingAttribution } from "@/lib/enquiries/integrations";

const QUERY_FIELDS: Record<string, keyof MarketingAttribution> = {
  utm_source: "utmSource",
  mx_utm_source: "utmSource",
  source: "utmSource",
  utm_medium: "utmMedium",
  mx_utm_medium: "utmMedium",
  utm_campaign: "utmCampaign",
  utm_term: "utmTerm",
  mx_term: "utmTerm",
  utm_content: "utmContent",
  campaignid: "campaignId",
  adgroupid: "adGroupId",
  keyword: "keyword",
  matchtype: "matchType",
  device: "device",
  creative: "creative",
  location: "location",
  gclid: "gclid",
  enquirytype: "enquiryType",
};

export function attributionFromUrl(url: string, initialReferrer = ""): MarketingAttribution {
  const parsed = new URL(url);
  const attribution: MarketingAttribution = {
    landingUrl: parsed.toString(),
    initialReferrer: initialReferrer || undefined,
  };
  for (const [queryName, field] of Object.entries(QUERY_FIELDS)) {
    const value = parsed.searchParams.get(queryName)?.trim();
    if (value && !attribution[field]) attribution[field] = value;
  }
  return attribution;
}
